const newsletterForm = class extends HTMLElement {
  constructor () {
    super()

    this.apiKey = this.dataset.apiKey
    this.listId = this.dataset.listId
    this.customSource = this.dataset.customSource
    this.type = this.dataset.type
    this.form = this.querySelector('[data-newsletter-form]')
    this.emailField = this.querySelector('[data-email-field]')
    this.phoneField = this.querySelector('[data-phone-field]')
    this.errorBanner = this.querySelector('[data-form-error]')
    this.successBanner = this.querySelector('[data-form-success]')
  }

  connectedCallback () {
    this.form && this.form.addEventListener('submit', (event) => {
      event.preventDefault()
      this.submitForm()
    })
  }

  submitForm () {
    this.errorBanner.classList.remove('show')
    this.successBanner.classList.remove('show')

    const formData = {
      data: {
        type: this.type,
        attributes: {
          ...(this.customSource) && {
            custom_source: this.customSource
          },
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email: this.emailField.value,
                phone_number: this.phoneField.value ? this.phoneField.value : null
              }
            }
          }
        },
        relationships: {
          list: {
            data: {
              type: 'list',
              id: this.listId
            }
          }
        }
      }
    }

    fetch(`https://a.klaviyo.com/client/subscriptions/?company_id=${this.apiKey}`, {
      method: 'POST',
      headers: {
        revision: '2024-02-15',
        'content-type': 'application/json'
      },
      body: JSON.stringify(formData)
    })
    .then((response) => {
      if (!response.ok) {
        throw Error(response.statusText)
      }
      return response
    })
    .then(() => {
      this.handleSuccess()
    })
    .catch((error) => {
      console.error(error)
      this.handleError()
    });
  }

  handleSuccess () {
    this.successBanner.classList.add('show')
    setTimeout(() => {
      this.successBanner.classList.remove('show')
      this.emailField.value = '';
      this.phoneField.value = '';
    }, 2500)
  }

  handleError() {
    this.errorBanner.classList.add('show')
    setTimeout(() => {
      this.errorBanner.classList.remove('show')
    }, 2500)
  }
}

if (typeof window.customElements.get('newsletter-form') === 'undefined') {
  window.customElements.define('newsletter-form', newsletterForm)
}
